import React, { useEffect, useState } from 'react';
import "./Faq.css";
import Breadcrumb_comp from '../common-components/breadcrumb-comp/Breadcrumb_comp';
import { Accordion } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { getFaq } from '../../features/faq/Slice';
import parse from "html-react-parser";

function Faq() {
    const breadcrumbs = [
        { label: "Home", link: "/", isActive: false },
        { label: "Faq", link: "", isActive: true },
    ];

    const faqData = useSelector((state) => state?.faq?.getfaq);
    const dispatch = useDispatch();
    const [searchTerm, setSearchTerm] = useState("");

  

    useEffect(() => {
        dispatch(getFaq());
    }, [dispatch]);

    // Flattening the dynamic payload for a single-level Accordion view as seen in your image
    // const allFaqs = faqData?.flatMap(item => item?.Faqs || []) || [];
    
    const filteredFaqs = faqData.filter(f => 
        f?.question?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <section className='Faq_page_holder'>
            <div className="container">
                <Breadcrumb_comp breadcrumbs={breadcrumbs} />
                
                {/* Centered Heading */}
                <div className='faq_title_container'>
                    <h2>Frequently Asked Questions</h2>
                    <div className='faq_search_wrapper'>
                        <span className='search_icon'>🔍</span>
                        <input 
                            type="text" 
                            placeholder="Search for a question" 
                            className="faq_search_input"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                </div>

                <div className='faq_holder'>
                    {filteredFaqs.length > 0 ? (
                        <Accordion>
                            {filteredFaqs.map((faqItem, index) => (
                                <Accordion.Item 
                                    className='custom_faq_item' 
                                    eventKey={String(index)} 
                                    key={`faq-${index}`}
                                >
                                    <Accordion.Header className='custom_faq_header'>
                                        {parse(faqItem?.question || "")}
                                    </Accordion.Header>
                                    <Accordion.Body className='custom_faq_body'>
                                        {parse(faqItem?.answer || "")}
                                    </Accordion.Body>
                                </Accordion.Item>
                            ))}
                        </Accordion>
                    ) : (
                        <div className="no_product_available_holder">
                            <h3>No FAQs Available</h3>
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
}

export default Faq;